<template>
  <div class="case" v-if="pcase">
    <DoctorCard
      v-if="pcase.schedule && pcase.schedule.assignee"
      :doctor-id="pcase.schedule.assignee.id"
    ></DoctorCard>
    <PatientCase :value="pcase.id"></PatientCase>
  </div>
</template>
<script>
import DoctorCard from '@/components/DoctorCard.vue'
import PatientCase from '@/components/Cases/PatientCase.vue'
import Fetch from '@/mixins/Fetch'
import { mapMutations } from 'vuex'
export default {
  mixins: [Fetch],
  components: {
    PatientCase,
    DoctorCard
  },
  metaInfo: {
    title: 'My Case'
  },
  data () {
    return {
      pcase: null
    }
  },
  mounted () {
    this.setNavVisible(false)
    this.setHead({ url: '/p/cases', text: this.$t('case') })
    this.fetchCase(this.$route.params.id, (c) => {
      this.setCase(c)
      this.pcase = c
    })
  },
  destroyed () {
    this.resetHead()
  },
  methods: {
    ...mapMutations({
      setHead: 'head/set',
      resetHead: 'head/reset',
      setNavVisible: 'app/setNavVisible',
      setCase: 'pcase/set'
    })
  }
}
</script>
<i18n>
{
  "ka": {
    "case": "ჩანაწერი"
  }
}
</i18n>
